import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

import Text from '../../Text';

type LabelProps = JSX.IntrinsicElements['label'] & {
    label: string;
    required?: boolean;
};

const Label: React.FC<LabelProps> = ({ label, required = false, className, ...restLabelProps }) => {
    const classes = useStyles();

    return (
        <span className={classes.container}>
            <span className={cn(classes.label, className)} {...restLabelProps}>
                {label}
            </span>
            {required && (
                <Text variant="t81" className={classes.required}>
                    Required
                </Text>
            )}
        </span>
    );
};

const useStyles = makeStyles(
    theme => ({
        container: {
            display: 'inline-flex',
            alignItems: 'center',
            paddingLeft: 8,
        },
        label: {
            color: theme.palette.greys[500],
            ...theme.typography.t81,
            lineHeight: '18px',
        },
        required: {
            color: theme.palette.primary[500],
            marginLeft: 4,
            fontWeight: 'normal',
        },
    }),
    { classNamePrefix: 'label' }
);

export default Label;
